import { render } from "./MainThietBiVaDichVu.vue?vue&type=template&id=dda04564&scoped=true"
import script from "./MainThietBiVaDichVu.vue?vue&type=script&lang=js"
export * from "./MainThietBiVaDichVu.vue?vue&type=script&lang=js"

import "./MainThietBiVaDichVu.vue?vue&type=style&index=0&id=dda04564&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda04564"]])

export default __exports__